/**
 * Frontend mirror of the backend `FourDBS.Canvas.Common.Constants.CanvasPermissions`
 * catalogue. Keep this in sync with
 * `src/DotNet/Shared/FourDBS.Canvas.Common/Constants/CanvasPermissions.cs`.
 *
 * Use these names with `PermissionService`, the `*hasPermission` / `*hasAnyPermission`
 * directives, `permissionGuard` route `data`, and `MenuItem.permission` instead of
 * hard-coded strings.
 */
export const CanvasPermissions = {
  EntityView: 'Entity.View',
  EntityUpdate: 'Entity.Update',
  AssetView: 'Asset.View',
  AssetUpdate: 'Asset.Update',
  UsersView: 'Users.View',
  UsersUpdate: 'Users.Update',
  AccountsView: 'Accounts.View',
  AccountsUpdate: 'Accounts.Update',
  PaymentsView: 'Payments.View',
  PaymentsUpdate: 'Payments.Update',
  ActivityView: 'Activity.View',
  BeneficiaryView: 'Beneficiary.View',
  BeneficiaryUpdate: 'Beneficiary.Update',
  BillingView: 'Billing.View',
  BillingUpdate: 'Billing.Update',
  CategoryView: 'Category.View',
  CertificateView: 'Certificate.View',
  CertificateUpdate: 'Certificate.Update',
  CustomerOnBoardingView: 'CustomerOnBoarding.View',
  CustomerOnBoardingUpdate: 'CustomerOnBoarding.Update',
  NotificationView: 'Notification.View',
  NotificationUpdate: 'Notification.Update',
  ProjectView: 'Project.View',
  ProjectUpdate: 'Project.Update',
  PublicFileView: 'PublicFile.View',
  PublicFileUpdate: 'PublicFile.Update',
  ReconciliationView: 'Reconciliation.View',
  ReconciliationUpdate: 'Reconciliation.Update',
  SurveyView: 'Survey.View',
  SurveyUpdate: 'Survey.Update',
  UnitsView: 'Units.View',
  OtaUpdateView: 'OtaUpdate.View',
  AuditView: 'Audit.View',
} as const;

export type CanvasPermission =
  (typeof CanvasPermissions)[keyof typeof CanvasPermissions];
